export const initialData = {
  nome: '',
  cpf: '',
  rg: '',
  uf_rg_id: 1,
  cep: '',
  logradouro: '',
  bairro: '',
  uf_endereco_id: 1,
  telefone: '',
  numero_endereco: '',
  numero_whatsapp: '',
  email: '',
  password: '',
  cidade: '',
  confirmacao_senha: '',
  anexo_cpf: '',
  tipo_pessoa_id: 1,
  check_termos: true,
  confirmacao_email: '',
}
